module.exports = __webpack_public_path__ + "assets/b55.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b55.png
// module id = 644
// module chunks = 0